// Hordeum Distichon Extract Hordeum Distichon (Barley)
// Extract
// Hordeum Distichon (Barley)
// Extract
// Hordeum Distichon (Barley)
// Extract
// Phenoxyethanol Phenoxyethanol Phenoxyethanol Phenoxyethanol

import React, { useState, useEffect, useContext } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Home_context } from '../../context/home_context';

// let dummy_data=[
//     {
//         'Brand':'YVIS PURE SKIN',
//         'Max. percentage':'0.000000',
//     },
//     {
//         'Brand':'SILVER COSMETICS',
//         'Max. percentage':'100.000000',
//     },
//     {
//         'Brand':'COSMETIC LAB',
//         'Max. percentage':'0.000000',
//     },
//     {
//         'Brand':'LALE',
//         'Max. percentage':'0.000000',
//     },
//     {
//         'Brand':'MARIE COSMETICS',
//         'Max. percentage':'0.000000',
//     },
//     {
//         'Brand':'MODELS',
//         'Max. percentage':'0.000000',
//     },
//     {
//         'Brand':'CLFA',
//         'Max. percentage':'0.000000',

//     }
// ]

export default function Blacklist() {
  const { report_data_state } = useContext(Home_context);
    let dummy_data='Hyaluronic Acid, Vitamin C, Retinol, Niacinamide, Salicylic Acid'

  return (
    // <div>
    //   <p className="page_headers  font-semibold text-start pt-2 header_color">
    //     BRAND RESTRICTION
    //   </p>
    //   <div className=" report_id_tables card">
    //     <DataTable
    //       value={report_data_state?.report_data['black_list_dummy_data']}
    //       showGridlines
    //       className="page_table_font_size"
    //     >
    //       <Column field="Brand" header="Brand"></Column>
    //       <Column field="Max. percentage" header="Max. percentage"></Column>
    //     </DataTable>
    //   </div>
    // </div>
    <div className="py-5">
      <p className="text-start font-semibold pt-2 page_headers header_color">
        BRAND RESTRICTION{' '}
      </p>
      <p className=" non_table_block_padding text-start page_pera_font_size page_pera_color ">
        {report_data_state?.report_data['restrictions']}
      </p>
      {/* <div className="non_table_block_padding flex gap-2 items-center">
          {dummy_data
            //   report_data_state?.report_data['identified_ingredients']
            .split(',')
            ?.map((el) => (
              <span className="text-start page_pera_font_size titles_cards ">
                {el}
              </span>
            ))}
        </div> */}
    </div>
  );
}



// import { useContext } from "react";
// import { Home_context } from "../../context/home_context";

// export default function Identified_ingredients(){
//       const { report_data_state } = useContext(Home_context);
//     let dummy_data='Hyaluronic Acid, Vitamin C, Retinol, Niacinamide, Salicylic Acid'
//     return (
//       <div className="py-5">
//         <p className="text-start font-semibold pt-2 page_headers header_color">
//           BRAND RESTRICTION{' '}
//         </p>
//         <div className="non_table_block_padding flex gap-2 items-center">
//           {dummy_data
//             //   report_data_state?.report_data['identified_ingredients']
//             .split(',')
//             ?.map((el) => (
//               <span className="text-start page_pera_font_size titles_cards ">
//                 {el}
//               </span>
//             ))}
//         </div>
//       </div>
//     );
// }

            // <p className="text-start font-semibold pt-2 page_headers header_color" >ORIGIN</p>
            // <p className="text-start" ><span className="page_pera_font_size font-semibold">Chemical category</span> : <span className="page_pera_font_size page_pera_color" >
            //     {/* Lipidic derivative / fatty substance */}
            //     </span></p>
